"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActiveCountdown;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _timeBlock = _interopRequireDefault(require("./time-block"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
const TimeBlocksContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TimeBlocksContainer",
  class: "core-t1jrd0m1"
});
const TimeSeparator = /*#__PURE__*/(0, _react2.styled)(TimeBlocksContainer)({
  name: "TimeSeparator",
  class: "core-timkk89"
});
const AriaAlert = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AriaAlert",
  class: "core-a1y9478e"
});

/**
* Render ActiveCountdown
*
* @param {object} props React props for ActiveCountdown element
* @param {string} props.title Active countdown's title
* @param {string} props.daysLabel Label for days time block
* @param {string} props.hoursLabel Label for hours time block
* @param {string} props.minutesLabel Label for minutes time block
* @param {string} props.secondsLabel Label for seconds time block
* @param {object} props.time Individual time block's values
* @param {string} props.alertMessage Screen reader alert message content
* @returns {React.ReactElement} ActiveCountdown component
* @public
*/
function ActiveCountdown({
  title,
  time,
  alertMessage,
  ...timeLabelProps
}) {
  const {
    daysLabel,
    hoursLabel,
    minutesLabel,
    secondsLabel
  } = timeLabelProps;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "title",
    className: "active-countdown-title",
    "data-cy": "active-countdown-title"
  }, title), /*#__PURE__*/_react.default.createElement(TimeBlocksContainer, {
    "data-cy": "time-blocks-container",
    className: "time-blocks-container"
  }, /*#__PURE__*/_react.default.createElement(_timeBlock.default, {
    dataCy: "days-block",
    timeValue: time.days,
    timeLabel: daysLabel
  }), /*#__PURE__*/_react.default.createElement(TimeSeparator, null, ":"), /*#__PURE__*/_react.default.createElement(_timeBlock.default, {
    dataCy: "hours-block",
    timeValue: time.hours,
    timeLabel: hoursLabel
  }), /*#__PURE__*/_react.default.createElement(TimeSeparator, null, ":"), /*#__PURE__*/_react.default.createElement(_timeBlock.default, {
    dataCy: "minutes-block",
    timeValue: time.minutes,
    timeLabel: minutesLabel
  }), /*#__PURE__*/_react.default.createElement(TimeSeparator, null, ":"), /*#__PURE__*/_react.default.createElement(_timeBlock.default, {
    dataCy: "seconds-block",
    timeValue: time.seconds,
    timeLabel: secondsLabel
  })), /*#__PURE__*/_react.default.createElement(AriaAlert, {
    role: "alert",
    "aria-live": "assertive"
  }, alertMessage));
}
ActiveCountdown.propTypes = {
  title: _propTypes.default.string,
  time: _propTypes.default.object.isRequired,
  alertMessage: _propTypes.default.string,
  timeLabelProps: _propTypes.default.object
};